<template>
	<transition name="slide-right" mode="out-in">
		<div :key="header" class="fs-3">
			<el-skeleton :loading="isLoading" animated>
				<template #template>
					<el-skeleton-item style="width: 240px" variant="h3" />
				</template>
				<template #default>
					{{ header }}
				</template>
			</el-skeleton>
		</div>
	</transition>
	<div class="row row-cols-3 flex-nowrap g-2 breadcrumb-nav mb-2">
		<div class="flex-fill"><hr /></div>
		<div class="col-auto d-flex">
			<transition name="fade" mode="out-in">
				<el-breadcrumb separator-icon="ArrowRightBold" class="d-flex flex-wrap" :key="breadcrumbs">
					<el-skeleton :loading="isLoading" animated class="d-flex">
						<template #template>
							<el-breadcrumb-item :to="{ name: 'home' }">
								<el-icon size="18px"><i class="bi bi-house-fill"></i></el-icon>
							</el-breadcrumb-item>
							<el-breadcrumb-item v-for="b in breadcrumbs.length" :key="b">
								<el-skeleton-item style="width: 100px" />
							</el-breadcrumb-item>
						</template>
						<template #default>
							<el-breadcrumb-item :to="{ name: 'home' }">
								<el-icon size="18px"><i class="bi bi-house-fill"></i></el-icon>
							</el-breadcrumb-item>
							<el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" :to="index < breadcrumbs.length ? { name: item.name } : ''">
								{{ item.label }}
							</el-breadcrumb-item>
						</template>
					</el-skeleton>
				</el-breadcrumb>
			</transition>
		</div>
		<div class="flex-fill"><hr /></div>
	</div>
</template>

<script>
export default {
	name: "PageHeader",
	data() {
		return {
			header: process.env.VUE_APP_TITLE,
		};
	},
	computed: {
		breadcrumbs() {
			const route = this.$route;
			const store = this.$store;
			const nav = route.matched
				.filter((f) => f.meta && f.meta.page)
				.map((r) => {
					const page = typeof r.meta.page === "function" ? r.meta.page(store, route) : r.meta.page;
					return { name: r.name, ...page };
				});

			return nav;
		},
		currentRoute() {
			return this.breadcrumbs.at(-1);
		},
		isLoading() {
			const { rombelId, siswaId } = this.$route.params;
			const rombelLoading = rombelId ? this.$store.getters["rombel/getStatusById"](rombelId) === "loading" : false;
			const siswaLoading = siswaId ? this.$store.getters["siswa/getStatusById"](siswaId) === "loading" : false;
			return rombelLoading || siswaLoading;
		},
	},
	props: {},
	watch: {
		currentRoute: {
			immediate: true,
			handler(val) {
				if (val) {
					this.header = val.header || this.breadcrumbs.at(-2)?.header;
					document.title = val.tab || this.breadcrumbs.at(-2)?.tab;
				}
			},
		},
	},
	mounted() {},
	methods: {},
};
</script>
<style scoped>
.breadcrumb-nav {
	filter: drop-shadow(0 0 1px #f7f9ff) drop-shadow(0 0 2px #f7f9ff) drop-shadow(0 0 4px #dae7f1) drop-shadow(0 0 8px #dae7f1) drop-shadow(0 0 8px #f7f9ff);
}
</style>
